import { CSSProperties, FC } from 'react';
import { IntlShape } from 'react-intl';

import styles from './available.module.scss';

import { ReactComponent as IconInfo } from '../../../../assets/images/info.svg';
import { formatDate } from '../../../../utils';

interface Props {
    from: Date | null;
    intl: IntlShape;
    styles?: CSSProperties;
    to: Date | null;
}

const Available: FC<Props> = ({ from, to, styles: stylesCustom, intl }) => {
    const dateFrom = from ? formatDate(from) : '';
    const dateTo = to ? formatDate(to) : '';

    if ((dateFrom || dateTo) && intl) {
        const availableFrom = intl.formatMessage(
            { id: 'general.availableFrom', defaultMessage: 'Gültig von: {dateFrom}' },
            { dateFrom }
        );
        const availableTo = intl.formatMessage(
            { id: 'general.availableTo', defaultMessage: 'Gültig bis: {dateTo}' },
            { dateTo }
        );

        return (
            <div className={styles.wrapper} style={stylesCustom}>
                <IconInfo />
                {dateFrom ? availableFrom : availableTo}
            </div>
        );
    }

    return null;
};

export default Available;
